import {CellButton, Div, FormItem, Group, Radio, RadioGroup, SplitCol, Title} from "@vkontakte/vkui";
import {
    Icon20FolderMoveOutline,
    Icon24DoorArrowRightOutline,
    Icon24Folder,
    Icon24FolderOutline, Icon24FolderSimpleOutline,
    Icon24HomeOutline,
    Icon24List, Icon24ListBulletSquareOutline, Icon24PhotosStackOutline, Icon24ShoppingCartOutline,
    Icon24SquareGrid3x3, Icon24UserCircleOutline, Icon24Video,
    Icon24VideoFillNone, Icon28Video, Icon56FolderPlusBadgeOutline
} from "@vkontakte/icons";
import React from "react";
import {AdaptivityContext, menu_collapsed_key, current_subdivision_key, getSavedSubdivision, checkCanViewCatalog, checkCanViewOst2} from "../assets/constants";
import SelectObject from "../assets/SelectObject";


class MainMenu extends React.Component {

    constructor(props) {
        super(props);


        let collapsed = false

        if (!AdaptivityContext.isMobile) {
            const collapsed_ = localStorage.getItem(menu_collapsed_key)
            if (collapsed_ == '1') {
                collapsed = true
            }
        }

        const selectedSubdivision = getSavedSubdivision(this.props.current_user);

        this.state = {
            collapsed,
            selectedSubdivision
        }

    }

    componentDidMount() {
        // Автоматически выбираем единственное подразделение, если оно одно и нет сохраненного выбора
        const { current_user } = this.props;
        if (current_user && 
            current_user.my_divisions && 
            current_user.my_divisions.length === 1 && 
            !this.state.selectedSubdivision) {
            
            const singleSubdivision = current_user.my_divisions[0];
            const transformedSubdivision = {
                id: singleSubdivision.external_id,
                external_id: singleSubdivision.external_id,
                name: singleSubdivision.name,
                title: singleSubdivision.alias || singleSubdivision.name,
                descr: singleSubdivision.name
            };

            this.setState({ selectedSubdivision: transformedSubdivision });
            localStorage.setItem(current_subdivision_key, JSON.stringify(transformedSubdivision));
        }
    }

    // Преобразует подразделения в формат для SelectObject
    transformSubdivisions = (subdivisions) => {

        if (!subdivisions || !Array.isArray(subdivisions)) return [];

        const result = subdivisions.map(subdivision => ({
            id: subdivision.external_id,
            external_id: subdivision.external_id,
            name: subdivision.name,
            title: subdivision.alias || subdivision.name,
            descr: subdivision.name
        }))
        console.log(result)
        return result
    }

    // Обработчик выбора подразделения
    onSubdivisionSelect = (subdivision) => {
        this.setState({selectedSubdivision: subdivision});
        localStorage.setItem(current_subdivision_key, JSON.stringify(subdivision));

        window.postMessage({type: 'divisionSelected', value: subdivision})


    }

    renderMenu = () => {
        const pkgVersion = require('../../package.json').version;
        const {current_user} = this.props

        return <Group className={"main-element " + (AdaptivityContext.isMobile ? 'mobile' : '')} style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "center",
            textAlign: "start",
            maxWidth: this.state.collapsed ? '50px' : '270px'
            /*background: "#0f65b9",
            color: "white"*/
        }}>
            {!AdaptivityContext.isMobile &&
                <CellButton before={this.state.collapsed && <Icon24ListBulletSquareOutline/>}
                            after={!this.state.collapsed && <Icon24ListBulletSquareOutline/>} mode="danger"
                            onClick={(e) => {
                                localStorage.setItem(menu_collapsed_key, this.state.collapsed ? '0' : '1')
                                this.setState({collapsed: !this.state.collapsed})

                            }}
                >

                </CellButton>}
            {!this.state.collapsed && <FormItem top="Способ отображения">
                <RadioGroup mode="horizontal">
                    <Radio name="list_mode" value="grid" checked>
                        <Icon24SquareGrid3x3/>
                    </Radio>
                    <Radio name="list_mode" value="list">
                        <Icon24List/>
                    </Radio>
                    <Radio name="list_mode" value="gallery">
                        <Icon24VideoFillNone/>
                    </Radio>
                </RadioGroup>
            </FormItem>}
            <CellButton before={<Icon24HomeOutline/>} mode="danger" data-story="default_story"
                        onClick={(e) => {
                            this.props.setActiveModal(null);
                            this.props.onStoryChange(e)
                        }}
            >
                {!this.state.collapsed && 'Главная'}
            </CellButton>
            {(current_user && current_user.address_program == '1' && current_user.position) &&
                <CellButton before={<Icon20FolderMoveOutline/>} mode="main" data-story="references_story"
                            onClick={(e) => {
                                this.props.setActiveModal(null);

                                this.props.onStoryChange(e)
                            }}
                >
                    {!this.state.collapsed && 'Адресная программа'}
                </CellButton>
            }
            {!(current_user && current_user.meta.settings && current_user.meta.settings.hide_ost == '1')
                && checkCanViewCatalog(current_user) &&
                <CellButton before={<Icon24FolderOutline/>} mode="main" data-story="ostatki_story"
                            onClick={(e) => {
                                this.props.setActiveModal(null);
                                this.props.setState({
                                    activePanelOstatki: 'ostatki_panel',
                                    monitoring_mode: false,
                                    ostatki_club_mode: false
                                });
                                this.props.setState({current_group_id: null});
                                this.props.onStoryChange(e)
                            }}
                >
                    {!this.state.collapsed && 'Каталог'}
                </CellButton>
            }


            {checkCanViewOst2(current_user) &&
                <CellButton before={<Icon24Folder/>} data-story="ostatki2_story"
                            onClick={(e) => {
                                this.props.setActiveModal(null);

                                this.props.setState({ostatki_club_mode: false, monitoring_mode: false});
                                this.props.setState({current_group_id: null});

                                this.props.onStoryChange(e)
                            }
                            }
                >
                    {!this.state.collapsed && 'Стендовая программа'}
                </CellButton>
            }
            <CellButton before={<Icon24List/>} data-story="saledocs_story"
                        onClick={(e) => {
                            this.props.setActiveModal(null);
                            this.props.onStoryChange(e)
                        }}
            >
                {!this.state.collapsed && 'Заказы'}
            </CellButton>
            {current_user && current_user.isRetail &&
                <CellButton before={<Icon24Video/>} data-story="monitoringdocs_story"
                            onClick={(e) => {
                                this.props.setActiveModal(null);
                                this.props.onStoryChange(e)
                            }}
                >
                    {!this.state.collapsed && 'Документы мониторинг'}
                </CellButton>}
            <CellButton before={<Icon24ShoppingCartOutline/>}
                        onClick={() => {
                            this.props.setActiveModal(null);
                            this.props.setActiveStory('cart_story')
                        }
                        }
            >
                {!this.state.collapsed && 'Корзина'}
            </CellButton>
            <hr/>
            <CellButton before={<Icon24PhotosStackOutline/>}
                        data-story="photo_storage_story"
                        onClick={(e) => {
                            this.props.setActiveModal(null);
                            this.props.onStoryChange(e)
                        }}
            >
                {!this.state.collapsed && 'Загрузка фото'}
            </CellButton>
            <hr/>
            {!this.state.collapsed && <CellButton before={<Icon24UserCircleOutline/>} mode="primary" multiline
            >
                {current_user ? current_user.name : ''}
                {current_user && current_user.position &&
                    <p>Должность: <b>{current_user.position}</b></p>}
                {current_user && current_user.application_version &&
                    <p>app
                        version: {current_user.application_version}</p>}
                {<p>web app version {pkgVersion}</p>}
            </CellButton>}
            {!this.state.collapsed && current_user && current_user.my_divisions && current_user.my_divisions.length > 0 &&
                <Div className="vkuiCellButton" style={{display:"flex", flexDirection: "row", width: "300px"}} >
                    <Icon24PhotosStackOutline/>
                    <SelectObject

                        title="Подразделение"
                        items={this.transformSubdivisions(current_user.my_divisions)}
                        selectObject={this.onSubdivisionSelect}
                        default={this.state.selectedSubdivision}
                        unselect_title="Выберите подразделение"
                        size="s"
                        mode="secondary"
                        btn_only

                    />
                </Div>
            }
            <hr/>
            <CellButton before={<Icon24DoorArrowRightOutline/>} mode="danger"
                        onClick={() => {
                            this.props.doLogout()
                        }}
            >
                {!this.state.collapsed && 'Выйти'}
            </CellButton>
        </Group>
    }

    render() {


        return (
            AdaptivityContext.isMobile ? this.renderMenu() :
                <SplitCol maxWidth={this.state.collapsed ? 60 : 280}>
                    {this.renderMenu()}
                </SplitCol>)

    }
}

export default MainMenu